module.exports = __webpack_public_path__ + "static/media/10-Liechtenstein@3x.4c258de3.jpg";